import React, { memo } from 'react';
import { ICellRendererParams } from '@trackman/baseball-shared-components';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { BaseRunnerWrapper, Divider, FinalState, InitialState } from './styles/BaseRunnerRendererStyles';

interface IProps {
  previousRowNameRef: string;
  nameRef: string;
}

const BaseRunnerRenderer: React.FC<IProps> = memo((props) => {
  const { previousRowNameRef, nameRef } = props;

  return (
    <BaseRunnerWrapper>
      <InitialState>{previousRowNameRef}</InitialState>
      <Divider />
      <FinalState>{nameRef}</FinalState>
    </BaseRunnerWrapper>
  );
});

const baseRunnerRenderer = (data: ICellRendererParams<any, PlayRow>) => {
  return (
    <BaseRunnerRenderer
      previousRowNameRef={
        (data.previousRow && data.previousRow[data.columnKey] && data.previousRow[data.columnKey]?.nameRef) || 'Undefined'
      }
      nameRef={data.value?.nameRef || 'Undefined'}
    />
  );
};

export default baseRunnerRenderer;
